import { render } from "./CategoryPositionListPage.vue?vue&type=template&id=a5fed932&scoped=true"
import script from "./CategoryPositionListPage.vue?vue&type=script&lang=js"
export * from "./CategoryPositionListPage.vue?vue&type=script&lang=js"

import "./CategoryPositionListPage.vue?vue&type=style&index=0&id=a5fed932&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a5fed932"

export default script